import { ReactNode } from "react";
import PublicNavbar from "@/project/karuna/components/PublicNavbar";
import PublicFooter from "@/project/karuna/components/PublicFooter";

interface PublicLayoutProps {
  children: ReactNode;
}

const PublicLayout = ({ children }: PublicLayoutProps) => {
  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-clip">
      <PublicNavbar />
      <main className="w-full flex-1 pt-16">{children}</main>
      <PublicFooter />
    </div>
  );
};

export default PublicLayout;
